module.exports = ".separator > h4 {\n    text-align: center;\n}\n\n#completeButtonRow {\n    text-align: right;\n}\n\n#completeButton {\n    margin: 16px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/dashboard/dashboard.component.css
// module id = ./src/app/core/components/dashboard/dashboard.component.css
// module chunks = main